const useEncargoStore = defineStore("encargo", () => {
  // states
  const encargo = ref({
    id: null,
    autor_id: null,
    solicitante_id: null,
    biografia_id: null,
    chat_id: null,
    calificacion: null, // 1 al 5
    testimonio: "",
    oferta_id: null,

    estatus: null, // 1 => Aceptado, 2 => Completado, 3 => cancelado, 4 => transferido
    solicitante: null,
    autor: null,
    biografia: null,
    oferta: null,
    entregas: [],
  });

  const encargos = ref([]);

  // getters
  const draft = computed(() => clone(encargo.value));

  // actions

  const clear = () => {
    encargo.value = {
      id: null,
      autor_id: null,
      solicitante_id: null,
      biografia_id: null,
      chat_id: null,
      calificacion: null,
      testimonio: "",
      oferta_id: null,

      estatus: null,
      solicitante: null,
      autor: null,
      biografia: null,
      oferta: null,
      entregas: [],
    };
  };

  const getVariantEstadoEncargo = (estatus) => {
    switch (estatus) {
      case 1:
      case "Aceptado":
        return "warning";
        break;

      case 2:
      case "Completado":
        return "success";
        break;

      case 3:
      case "Cancelado":
        return "danger";
        break;

      case 4:
      case "Transferido":
        return "info";
        break;

      default:
        return "secondary";
        break;
    }
  };

  const getEstadoEncargo = (estatus) => {
    switch (estatus) {
      case 1:
      case "Aceptado":
        return "Por Entregar";
        break;

      case 2:
      case "Completado":
        return "Entregado";
        break;

      case 3:
      case "Cancelado":
        return "Cancelado";
        break;

      case 4:
      case "Transferido":
        return "Transferido";
        break;

      default:
        return "N/A";
        break;
    }
  };

  const setBiografiaId = (biografia_id) => {
    encargo.value.biografia_id = biografia_id;
  };

  const setEncargo = (datos) => {
    encargo.value = datos || encargo.value;
  };

  const marcarEntregado = (encargo_id) => {
    if (encargo.value.id === encargo_id) {
      encargo.value.estado = "Completado";
    }
  };

  const fetch = async (encargo_id) => {
    try {
      const { data } = await axios.get(
        `/api/encargos/${encargo_id}/fetch-data`
      );
      if (data.id) {
        encargo.value = data;
      }
      return data;
    } catch (error) {
      throw error;
    }
  };

  const fetchData = async (params) => {
    try {
      const { data } = await axios.post("/api/encargos/fetch-data", params);
      return data;
    } catch (error) {
      throw error;
    }
  };

  const guardar = async (payload) => {
    try {
      const { data } = await axios.put(`/api/encargos/${payload.id}`, payload);
      if (data.result) {
        encargo.value = data.data;
      }
      return data;
    } catch (error) {
      throw error;
    }
  };

  const eliminar = async (encargo_id) => {
    try {
      const { data } = await axios.delete(`/api/encargos/${encargo_id}`);
      return data;
    } catch (error) {
      throw error;
    }
  };

  const inicializarBiografia = async (encargo_id) => {
    try {
      const { data } = await axios.get(
        `/api/encargos/${encargo_id}/inicializar-biografia`
      );
      return data;
    } catch (error) {
      throw error;
    }
  };

  const entregar = async (encargo_id) => {
    try {
      const { data } = await axios.get(`/api/encargos/${encargo_id}/entregar`);
      return data;
    } catch (error) {
      throw error;
    }
  };
  const setCalificacion = (enc) => {
    if (encargo.value.id === enc.id) {
      encargo.value.calificacion = enc.calificacion;
      encargo.value.testimonio = enc.testimonio;
    }

    let i = encargos.value.findIndex((e) => e.id === enc.id);
    if (i !== -1) {
      encargos.value[i].calificacion = enc.calificacion;
      encargos.value[i].testimonio = enc.testimonio;
    }
  };

  const guardarCalificacion = async (payload, encargo_id) => {
    try {
      const { data } = await axios.put(
        `/api/encargos/${encargo_id}/calificar`,
        payload
      );
      if (data.result) {
        setCalificacion(data.encargo);
      }
      return data;
    } catch (error) {
      throw error;
    }
  };

  return {
    encargo,
    encargos,
    //getters
    draft,
    //actions
    clear,
    fetch,
    fetchData,
    guardar,
    eliminar,
    getEstadoEncargo,
    getVariantEstadoEncargo,
    inicializarBiografia,
    setBiografiaId,
    setEncargo,
    entregar,
    marcarEntregado,
    setCalificacion,
    guardarCalificacion,
  };
});

export default useEncargoStore;
